var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"select-menu-close-btn d-block",attrs:{"color":"primary"}},[_vm._v("mdi-close")])
}
var staticRenderFns = []

export { render, staticRenderFns }